import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image", "dot"]
  static values = { url: String, focalX: { type: Number, default: 50 }, focalY: { type: Number, default: 50 } }

  connect() {
    this.updateDotPosition()
  }

  pick(event) {
    event.preventDefault()
    const rect = this.imageTarget.getBoundingClientRect()
    const x = ((event.clientX - rect.left) / rect.width * 100).toFixed(1)
    const y = ((event.clientY - rect.top) / rect.height * 100).toFixed(1)

    this.focalXValue = parseFloat(x)
    this.focalYValue = parseFloat(y)
    this.updateDotPosition()
    this.save()
  }

  updateDotPosition() {
    this.dotTarget.style.left = `${this.focalXValue}%`
    this.dotTarget.style.top = `${this.focalYValue}%`
  }

  async save() {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    await fetch(this.urlValue, {
      method: "PATCH",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": token },
      body: JSON.stringify({ focal_x: this.focalXValue, focal_y: this.focalYValue })
    })
  }
}
